import { useCallback } from 'react';
import compact from 'lodash/compact';

import { airbridgeTracker } from '@common/marketing-tracker';
import { GetPdpBaseInfo_catalog_product_base_info_product } from '@domains/pdp-common';

export const useAirBridgeProductShareEvents = ({
  catalogProduct,
}: {
  catalogProduct: GetPdpBaseInfo_catalog_product_base_info_product;
}) => {
  const usedCategories = compact(catalogProduct.managed_category_list);

  const combinedCategories = usedCategories?.reduce(
    (prev, curr, index) =>
      index === 0
        ? {
            label: curr.value,
            id: curr.id,
            name: curr.value,
          }
        : {
            ...prev,
            id: prev.id.concat(', ', curr.id),
            name: prev.name.concat(', ', curr.value),
          },
    { label: '', id: '', name: '' },
  );

  const onAirBridgeShare = useCallback(
    (sharedChannel: 'kakao' | 'copy_link') => {
      airbridgeTracker.events.send('airbridge.share', {
        label: combinedCategories?.label,
        semanticAttributes: {
          sharedChannel,
          products: [
            {
              categoryID: combinedCategories?.id,
              categoryName: combinedCategories?.name,
              productID: catalogProduct.id,
              name: catalogProduct.name,
            },
          ],
        },
      });
    },
    [catalogProduct.id, catalogProduct.name, combinedCategories],
  );

  return { onAirBridgeShare };
};
